import { render, staticRenderFns } from "./QuicktypeModel.vue?vue&type=template&id=3807b824&"
import script from "./QuicktypeModel.vue?vue&type=script&lang=ts&"
export * from "./QuicktypeModel.vue?vue&type=script&lang=ts&"
import style0 from "./QuicktypeModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports